import React from "react";
import {
  Box,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

const PaymentSuccessPage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        p: 2,
      }}
    >
      <Card
        sx={{
          maxWidth: 450,
          width: "100%",
          borderRadius: 3,
          boxShadow: theme.shadows[6],
          textAlign: "center",
          p: isMobile ? 2 : 4,
        }}
      >
        <Avatar
          sx={{
            width: 80,
            height: 80,
            mx: "auto",
            mb: 3,
            bgcolor: theme.palette.success.main,
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 50, color: theme.palette.common.white }}
          />
        </Avatar>

        <CardContent>
          <Typography
            variant="h5"
            component="div"
            gutterBottom
            sx={{ fontWeight: 600, mb: 2 }}
          >
            Payment Method Added Successfully!
          </Typography>

          <Typography
            variant="body1"
            color="text.secondary"
            sx={{ mb: 2, lineHeight: 1.6 }}
          >
            Your payment method has been securely saved and verified for future
            transactions.
          </Typography>

          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ fontStyle: "italic", mt: 3, lineHeight: 1.6 }}
          >
            You can now safely close this window and return to your purchase
            experience.
          </Typography>

          <Button
            variant="contained"
            sx={{ mt: 4 }}
            onClick={handleGoBack}
          >
            Go Back
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
};

export default PaymentSuccessPage;
